import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store'

export interface IWorkspaceFormData {
    wsid: string
}

export interface IWorkspaceResponse {
    statusCode: number | string
    data: any
}

export interface WorkspaceState {
    workspaceData: IWorkspaceResponse | null
}

const initialState: WorkspaceState = {
    workspaceData: null,
}

const workspaceSlice = createSlice({
    name: 'workspacedata',
    initialState,
    reducers: {
        setWorkspaceData: (state, action: PayloadAction<IWorkspaceResponse>) => {
            state.workspaceData = action.payload
        },
    },
})

export const workspaceFormAPI = createApi({
    reducerPath: 'workspaceFromAPI', //our reducer lives at store.reducer
    tagTypes: ['workspaceFormData'],
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3' ), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        submitForm: build.mutation<IWorkspaceResponse, { wsid: string }>({
            query: ({ wsid }) => ({
                url: `/workspace/${wsid}`,
                method: 'GET',
            }),
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                } catch (error) {
                    console.error('Error Fetching Detail Workspace: ', error)
                }
            },
        }),
    }),
})

export const { setWorkspaceData } = workspaceSlice.actions
export const getWorkspaceData = (state: RootState) => state.workspacedata.workspaceData
export default workspaceSlice.reducer
export const { useSubmitFormMutation } = workspaceFormAPI
